import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import * as tx from '../../../../constants/strings';
import { URL_SELL_GENERAL } from '../../../../constants/urls';

import BlockElementHorizontalProduct from '../BlockElementHorizontalProduct';
import { LoadingIcon } from '../../../Icons/LoadingIcon';

import * as productActionCreators from '../../../../actions/product';
const allActionCreators = Object.assign({}, productActionCreators);

export class BlockFeaturedBuylistVertical extends Component {

  constructor(props) {
    super(props);

    this.REQUEST_COUNT = 10;

    this.state = {
      loading: true,

      targetProducts: this.REQUEST_COUNT,

      productData: null,
    };

    this.bodyElement = React.createRef();
    this.scrollElement = React.createRef();

    // Controllers
    this.controller = null;
  }

  componentDidMount() {
    this.fetchBuylistProducts();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.bodyElement && this.bodyElement.current && this.scrollElement && this.scrollElement.current) {
      if(this.scrollElement.current.getBoundingClientRect().height > this.bodyElement.current.getBoundingClientRect().height) {
        this.setState({ targetProducts: this.state.targetProducts - 1 });
      }
    }
  }

  async fetchBuylistProducts() {
    
    // Cancel any existing requests
    if(this.controller) {
      this.controller.abort();
    }
    const controller = new AbortController();
    this.controller = controller;

    this.setState({ 
      loading: true, 
    });

    // // Use these for an inventory search response
    // const buylistFilters = { 
    //   [FV_KEY_IS_BUYLIST]: true,
    // };

    // const paginationData = {
    //   limit: this.REQUEST_COUNT,
    //   offset: 0,
    // }

    // const reqFilterObject = Object.assign({}, buylistFilters, paginationData);
    // const productResp = await this.props.productSearchInventory(reqFilterObject, controller.signal)

    // Use these to pull up specific SKUs
    const skus = [
      'MTG#000439455', // Delney, Streetwise Lookout
      'MTG#000173163', // Bloodletter of Aclazotz
      'MTG#000082903', // Faerie Mastermind
      'MTG#000041077', // Tyrranax Rex
      'MTG#000384978', // Shivan Dragon
    ];
    
    const productResp = await this.props.productFetchBySkus(skus, controller.signal)
      .catch((errResp) => {
        this.setState({
          productData: [],
          loading: false, 
        });
      });

    if(!productResp) {
      return null;
    }

    this.setState({
      productData: productResp.data,
      loading: false, 
    });
  }

  render() {

    let productsRendered = 0;
    const {t} = this.props;

    return <div className={'BlockFeaturedBuylistVertical BlockTypeProductsVertical'}>
      <div className='btpvLiner'>
        <div className='horizontalRowTitle'>
          <div className='FlexCenter'>{this.props.block.isDefaultConfig('title') ? t(this.props.block.getConfigAttr('title')) : this.props.block.getConfigAttr('title')}</div>
        </div>

        <div className='horizontalRowBody' ref={this.bodyElement}>
          {this.state.loading ?
            <div className='horiontalRowBodyIcon'>
              <LoadingIcon />
            </div> :
            <div className='horizontalRowBodyLiner' ref={this.scrollElement}>
              {this.state.productData && this.state.productData.length > 0 ?
                <>
                  {this.state.productData.map((prod, i) => {

                    if(productsRendered >= this.state.targetProducts) {
                      return null;
                    }
                    productsRendered++;

                    return <div key={i} className='elementWrapper'>
                      <BlockElementHorizontalProduct
                        isBuylist={true}
                        product={prod} />
                    </div>
                  })}
                </> :
                <div className='noResults'>
                  {t(tx.TX_GALLERY_NO_RESULTS)}
                </div>
              }
            </div>
          }
        </div>

        <div className='horizontalRowActionFooter'>
          <Link to={URL_SELL_GENERAL} className='horizontalRowAction'>{t(tx.TX_VIEW)}</Link>
        </div>
      </div>
    </div>;
  }
}

function mapStateToProps(state) {
  return {

  };
}

export default connect(mapStateToProps, allActionCreators)(withTranslation()(BlockFeaturedBuylistVertical));